'use client'

import { useParams } from 'next/navigation'

import { ButtonClick, track } from '@dfds-frontend/tracking'

import { useTranslation } from '@/hooks/useDebugTranslations'

import Dialog from '../Dialog'

interface Props {
  show: boolean
}

const OfferInvalidModal: React.FC<Props> = ({ show }) => {
  const { t } = useTranslation()
  const params = useParams()

  return (
    <Dialog
      dataAttr="invalid-offer"
      description={t('INVALID-OFFER-DESCRIPTION')}
      headline={t('INVALID-OFFER-HEADING')}
      onPrimaryButtonClicked={() => {
        track<ButtonClick>({
          clickedElementText: 'selectNonInvalidOffer',
          event: 'buttonClick',
          eventAction: 'invalidOffer',
        })
        const restartBookingUrl = sessionStorage.getItem('restartBookingUrl')! // should always be set
        const url = new URL(restartBookingUrl, window.location.origin)
        url.searchParams.delete('offer')
        window.location.replace(url.toString())
      }}
      onSecondaryButtonClicked={() => {
        track<ButtonClick>({
          clickedElementText: 'startOver',
          event: 'buttonClick',
          eventAction: 'invalidOffer',
        })
        const locale = params?.locale || 'en'
        const baseUrl = window.location.origin
        window.location.href = `${baseUrl}/${locale}`
      }}
      primaryButtonText={t('INVALID-OFFER-BTN-PRIMARY')}
      secondaryButtonText={t('INVALID-OFFER-BTN-SECONDARY')}
      show={show}
    />
  )
}

export default OfferInvalidModal
